import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import nameSort from 'scaleflow/utils/nameSort';

export default class InitiativesTableRoadmapSelectorComponent extends DropdownActivator {
  @service store;

  @tracked roadmapFormIsVisible = false;

  selectedInitiative = null;

  get initiative() {
    return this.args.initiative;
  }

  @action
  handleRoadmapClick(initiative, e = []) {
    try {
      initiative.roadmaps = e
        .map((id) => this.store.peekRecord('roadmap', id))
        .filter((item) => item);
      initiative.save();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  toggleRoadmapForm(initiative, val) {
    if (initiative) this.selectedInitiative = initiative;
    else this.selectedInitiative = null;
    if (val !== undefined) this.roadmapFormIsVisible = val;
    else this.roadmapFormIsVisible = !this.roadmapFormIsVisible;
  }

  @action
  async onRoadmapAdded(roadmap) {
    const roadmaps = [...this.selectedInitiative.roadmaps.content];
    roadmaps.push(roadmap);
    this.selectedInitiative.roadmaps = roadmaps;
    await this.selectedInitiative.save();
  }

  get sortedRoadmaps() {
    return this.initiative.roadmaps?.content?.toSorted((a, b) =>
      nameSort(a.title, b.title, 'asc'),
    );
  }

  get firstRoadmap() {
    return this.sortedRoadmaps?.[0];
  }

  willDestroy() {
    this.roadmapFormIsVisible = false;
    this.selectedInitiative = null;
    super.willDestroy(...arguments);
  }
}
